import React, { Component } from 'react';
import axios from 'axios';

import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { DropDownList, DropDownListChild } from '../../Elements/Select/dropdown';
import ButtonLoader from '../../Elements/Button/button';
import ResourcePagination from '../../Elements/Pagination/resourcepagination';
import EventPagination from '../../Elements/Pagination/eventpagination';

import ImageUploader from 'react-images-upload';
import cookie from 'react-cookies';
import Checkbox from '@material-ui/core/Checkbox';

import Moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {toBase64, updateValueInJson, ValidateArrayState} from '../../../functions';
import {
    API_URL,
    BASE_URL_CMS,
    BASE_URL_RECURSOS,
    BASE_URL_FRONTEND
} from '../../../constants';
import {ValidateState} from '../../../functions';
import TextareaWithCounter from '../../Elements/TextareaWithCounter';

//tabs
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import BulletinIcon from '@material-ui/icons/EventNote';
import ImagenIcon from '@material-ui/icons/Image';
import DocumentIcon from '@material-ui/icons/AttachFile';

import InComponentLoader from '../../Elements/Loader/componentloader';
import ThumbnailGrid from '../../Elements/Thumbnail/thumbnail';

import '../../../assets/css/siicex-usuario.css';
import { PaginationImages } from '../../Elements/Pagination/ImgPagination';
import InputWithCounter from '../../Elements/InputWithCounter';
import ImgUploader, {ModalImages} from '../../Elements/imgUploader';

function TabPanel(props) {
    const { children, value, index } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-prevent-tabpanel-${index}`}
            aria-labelledby={`scrollable-prevent-tab-${index}`}
        >
            <Box>
                {children}
            </Box>
        </Typography>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

class AddEventos extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isReprogramado: false,
            event:      {
                Even_Titulo:                "",
                Even_Extracto:              "",
                Even_ImagenPortada:         "",
                Even_ImagenPortadaMovil:    "",
                Even_Estado:                "",
                Even_EstadoActividad:       "",
                Even_CoOrganizador:       "",
                Even_Activo:                "",
                Even_Tipo:                  "",
                Even_TipoAsistencia:        "",
                Even_Enlace:                "",
                Even_Direccion:             "",
                Even_LugarEvento:           "",
                Even_FechaPublicacion:      new Date(),
                Even_FechaInicio:           new Date(),
                Even_FechaFin:              new Date(),
                Even_UsuarioCreacion:       "",
                listEventoFichaProducto:    [],
                listEventoLineaProducto:    [],
                listEventoPais:             [],
                listEventoPartida:          "",
                listEventoSector:           [],
                Even_FechaReproIni: null,
                Even_FechaReproFin: null,
                Even_FechaIncripcionIni: null,
                Even_FechaIncripcionFin: null,
                Even_CancelarMotivo: "",
            },
            listCoorganizadores: [],
            response:   [],
            error:      [],
            sectors:    [],
            roles:      [],
            estadoa:    [],
            loading:    false,
            
            security: cookie.load('user'),

            numeroTab: 0,
            HTML: '<span>&nbsp</span>',

            imagesToSelect: false,
            selectedImage:  false,
            selectedFile:   false,
            currentImagePage: 1,

            selectsLoadedCount: 0,
            selectsLoaded: false,

            flagimg:   ""
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInputChangeDate = this.handleInputChangeDate.bind(this);

        this.onLoad = this.onLoad.bind(this);
        this.changeImg = this.changeImg.bind(this);
    }

    handleInputChangeDate = (name, val) => {
        let { event } = this.state;
        event[name] = val ? val : null; 
        this.setState({ event });
    };

    handleToggleReprogramado = (event) => {
        this.setState({ isReprogramado: event.target.checked }, () => {
            if (!this.state.isReprogramado) {
                let copy = JSON.parse(JSON.stringify(this.state.event));
                copy.Even_FechaReproIni = null;
                copy.Even_FechaReproFin = null;
                this.setState({ event: copy });
            }
            });
        }

    handleInputChange(event){
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copy = JSON.parse(JSON.stringify(this.state.event));
        copy[target.name] = value;
        if(event.target.id==="sTitulo"){
            let _value = event.target.value.toLocaleLowerCase();
            [   {val: " ", replace: "-"},
                {val: "á", replace: "a"},
                {val: "é", replace: "e"},
                {val: "í", replace: "i"},
                {val: "ó", replace: "o"},
                {val: "ú", replace: "u"},
            ].forEach((letter) => {
                while(_value.indexOf(letter.val)!=-1) _value = _value.replace(letter.val, letter.replace);
            });

            copy['sUrlCanonical'] = _value;
        }
        this.setState({ event: copy });
    }

    handleClickCancel(e){
        // const {history: {push}} = this.props;
        // window.location.href = BASE_URL_CMS + "/eventos";
        this.props.history.push({
            pathname: '/eventos',
        });
    }

    // #save #grabar
    callFunctionButton = (event) => {
        let _isOk = true;

        const {history: {push}}         = this.props;
        const url                       = `${API_URL}EventUX`;
        var dataForm                    = this.state.event;

        var Even_Estado                 = dataForm.Even_Estado;
        var Even_EstadoActividad        = dataForm.Even_EstadoActividad;
        
        let coorgVal = dataForm.Even_CoOrganizador && dataForm.Even_CoOrganizador.value !== undefined 
            ? dataForm.Even_CoOrganizador.value 
            : dataForm.Even_CoOrganizador;
        coorgVal = (coorgVal == 0 || coorgVal === "0") ? "" : coorgVal;

        var Even_Activo                 = dataForm.Even_Activo;
        var Even_Tipo                   = dataForm.Even_Tipo;
        var Even_TipoAsistencia         = dataForm.Even_TipoAsistencia;
        var listEventoPartida           = dataForm.listEventoPartida;
        var partida                     = listEventoPartida ? listEventoPartida.filter((v) => v.hasOwnProperty("value")).map((v) => v.value) : listEventoPartida;

        // dataForm = updateValueInJson(dataForm,'Even_Estado', Even_Estado.value);
        // dataForm = updateValueInJson(dataForm,'Even_EstadoActividad', Even_EstadoActividad.value);
        // dataForm = updateValueInJson(dataForm,'Even_Activo', Even_Activo.value);
        // dataForm = updateValueInJson(dataForm,'Even_Tipo',   Even_Tipo.value);
        // dataForm = updateValueInJson(dataForm,'Even_TipoAsistencia',   Even_TipoAsistencia.value);

        dataForm = updateValueInJson(dataForm,'Even_Estado', Even_Estado ? Even_Estado.value : "");
        dataForm = updateValueInJson(dataForm,'Even_EstadoActividad', Even_EstadoActividad ? Even_EstadoActividad.value : "");
        dataForm = updateValueInJson(dataForm,'Even_Activo', Even_Activo ? Even_Activo.value : "");
        dataForm = updateValueInJson(dataForm,'Even_Tipo', Even_Tipo ? Even_Tipo.value : "");
        dataForm = updateValueInJson(dataForm,'Even_TipoAsistencia', Even_TipoAsistencia ? Even_TipoAsistencia.value : "");

        dataForm = updateValueInJson(dataForm,'Even_ImagenPortada', (dataForm.sImagen && dataForm.sImagenMovil !== "")  ?  dataForm.sImagen: "");
        dataForm = updateValueInJson(dataForm,'Even_ImagenPortadaMovil', (dataForm.sImagenMovil && dataForm.sImagenMovil !== "")  ? dataForm.sImagenMovil : "");

        let fInicio = dataForm.Even_FechaInicio;
        let fFin = dataForm.Even_FechaFin;
        
        if (fInicio || fFin) {
            if (!fInicio || !fFin) {
                toast.error('Debe ingresar la fecha de inicio y término del evento');
                _isOk = false;
            } else if (Moment(fFin).isBefore(Moment(fInicio), 'day')) {
                toast.error('La fecha fin del evento no puede ser menor a la fecha de inicio');
                _isOk = false;
            }
        }

        let fInsIni = dataForm.Even_FechaIncripcionIni;
        let fInsFin = dataForm.Even_FechaIncripcionFin;

        if (fInsIni || fInsFin) {
            if (!fInsIni || !fInsFin) {
                toast.error('Debe ingresar ambas fechas de inscripción');
                _isOk = false;
            } else if (Moment(fInsFin).isBefore(Moment(fInsIni), 'day')) {
                toast.error('La fecha fin de inscripción no puede ser menor a la fecha de inicio');
                _isOk = false;
            }
        }

        let fReproIni = dataForm.Even_FechaReproIni;
        let fReproFin = dataForm.Even_FechaReproFin;
        
        if (this.state.isReprogramado) {
            if (this.state.isReprogramado || fReproIni || fReproFin) {
                if (!fReproIni || !fReproFin) {
                    toast.error('Debe ingresar ambas fechas de reprogramación');
                    _isOk = false;
                } else if (Moment(fReproFin).isBefore(Moment(fReproIni), 'day')) {
                    toast.error('La fecha de fin de reprogramación no puede ser menor a la de inicio');
                    _isOk = false;
                }
            }
        }

        if( this.state.event.Even_Estado && this.state.event.Even_Estado.hasOwnProperty("value") && this.state.event.Even_Estado.value === "P")
        {
            if(ValidateState(dataForm, 'Even_Titulo', '')){toast.error('Error en Validación: Ingrese un Título.'); _isOk = false;}
            if(dataForm.Even_Tipo.toString() === "0"){dataForm = updateValueInJson(dataForm,'Even_Tipo', "");}
            if(dataForm.Even_TipoAsistencia.toString() === "0"){dataForm = updateValueInJson(dataForm,'Even_TipoAsistencia', ""); }
            if(ValidateState(dataForm, 'Even_EstadoActividad', '')){toast.error('Seleccione un estado de actividad.'); _isOk = false;}
        }else{

            if(ValidateState(dataForm, 'Even_Estado', '')){toast.error('Error en Validación: Seleccione un estado.'); _isOk = false;}
            if(ValidateState(dataForm, 'Even_EstadoActividad', '')){toast.error('Error en Validación: Seleccione un estado de actividad.'); _isOk = false;}
            if(ValidateState(this.state.event, 'Even_Activo', '')){toast.error('Error en Validación: Activo.'); _isOk = false;}

            if(ValidateArrayState(dataForm, 'Even_Tipo', '')){toast.error('Error en Validación: Ingrese un tipo.'); _isOk = false;}
            if(ValidateArrayState(dataForm, 'Even_TipoAsistencia', '')){toast.error('Error en Validación: seleccione un tipo de asistencia.'); _isOk = false;}
            
            if(ValidateState(this.state.event, 'Even_Titulo', '')){toast.error('Error en Validación: Ingrese un Título.'); _isOk = false;}
            if(ValidateState(this.state.event, 'Even_Extracto', '')){toast.error('Error en Validación: Ingrese un Extracto.'); _isOk = false;}
            if(ValidateState(dataForm, 'Even_ImagenPortada', '')){toast.error('Error en Validación: Ingrese una imagen de portada.'); _isOk = false;}
            // if(ValidateState(dataForm, 'Even_ImagenPortadaMovil', '')){toast.error('Error en Validación: Ingrese una imagen de portada (movil).'); _isOk = false;}

            if(ValidateState(this.state.event, 'even_Enlace', '')){toast.error('Error en Validación: Ingrese un enlace.'); _isOk = false;}
            if(ValidateState(this.state.event, 'even_Direccion', '')){toast.error('Error en Validación: Ingrese una dirección.'); _isOk = false;}
            if(ValidateState(this.state.event, 'even_LugarEvento', '')){toast.error('Error en Validación: Ingrese un lugar de evento.'); _isOk = false;}

            if(ValidateArrayState(dataForm,     'listEventoFichaProducto', '')){  toast.error('Error en Validación: Seleccione una ficha de producto.'); _isOk = false; }
            if(ValidateState(dataForm,          'listEventoPais', '')){  toast.error('Error en Validación: Seleccione al menos una Ubicación.'); _isOk = false; }
            // if(ValidateArrayState(dataForm,     'listEventoPartida', '')){  toast.error('Error en Validación: Seleccione al menos una Partida.'); _isOk = false; }
            if(ValidateArrayState(dataForm,     'listEventoSector', '')){  toast.error('Error en Validación: Seleccione al menos un Sector.'); _isOk = false; }
            // if(ValidateArrayState(dataForm,     'listEventoLineaProducto', '')){  toast.error('Error en Validación: Seleccione linea de producto.'); _isOk = false; }
        }

        if(!_isOk){
            event.preventDefault();
            return;
        }

        dataForm = updateValueInJson(dataForm,'Even_UsuarioCreacion', this.state.security.nUsuCodigo);
        dataForm = updateValueInJson(dataForm,'Even_FechaFin', Moment(dataForm.Even_FechaFin).format("YYYY-MM-DD"));
        dataForm = updateValueInJson(dataForm,'Even_FechaInicio', Moment(dataForm.Even_FechaInicio).format("YYYY-MM-DD"));
        dataForm = updateValueInJson(dataForm,'Even_FechaPublicacion', Moment(dataForm.Even_FechaPublicacion).format("YYYY-MM-DD"));

        var listEventoSector            = dataForm.listEventoSector;
        var listEventoLineaProducto     = dataForm.listEventoLineaProducto;
        var listEventoPais              = dataForm.listEventoPais;
        var listEventoFichaProducto     = dataForm.listEventoFichaProducto;
        
        var dlistEventoSector           = (listEventoSector || []).map(v => (v && v.value) ? v.value.split("-")[0] : v);
        var dlistEventoLineaProducto    = (listEventoLineaProducto || []).map(v => (v && v.value) ? v.value : v);
        var dlistEventoPais             = (listEventoPais || []).map(v => (v && v.value) ? v.value : v);
        var dlistEventoFichaProducto    = (listEventoFichaProducto || []).map(v => (v && v.value) ? v.value : v);

        // var dlistEventoPartida          = listEventoPartida.map(v => v.value);
        //dataForm = updateValueInJson(dataForm,'listEventoSector', String(dlistEventoSector));
        dataForm = updateValueInJson(dataForm,'listEventoSector', String(dlistEventoSector));
        dataForm = updateValueInJson(dataForm,'listEventoLineaProducto', String(dlistEventoLineaProducto));
        dataForm = updateValueInJson(dataForm,'listEventoPartida', String((partida === null ? "" : partida)));
        dataForm = updateValueInJson(dataForm,'listEventoPais', String(dlistEventoPais));
        dataForm = updateValueInJson(dataForm,'listEventoFichaProducto', String(dlistEventoFichaProducto));

        this.setState({loading:true});

        delete dataForm.sImagen;
        delete dataForm.sImagenMovil;
        // const formData = JSON.stringify(dataForm);
        let formatData = {
            ...dataForm,
            Even_CoOrganizador: coorgVal, 
            Even_Enlace: dataForm.even_Enlace || dataForm.Even_Enlace || "",
            Even_Direccion: dataForm.even_Direccion || dataForm.Even_Direccion || "",
            Even_LugarEvento: dataForm.even_LugarEvento || dataForm.Even_LugarEvento || "",
            
            Even_FechaReproIni: (this.state.isReprogramado && dataForm.Even_FechaReproIni) ? Moment(dataForm.Even_FechaReproIni).format("YYYY-MM-DD") : null,
            Even_FechaReproFin: (this.state.isReprogramado && dataForm.Even_FechaReproFin) ? Moment(dataForm.Even_FechaReproFin).format("YYYY-MM-DD") : null,
            Even_FechaIncripcionIni: dataForm.Even_FechaIncripcionIni ? Moment(dataForm.Even_FechaIncripcionIni).format("YYYY-MM-DD") : null,
            Even_FechaIncripcionFin: dataForm.Even_FechaIncripcionFin ? Moment(dataForm.Even_FechaIncripcionFin).format("YYYY-MM-DD") : null
        };
        delete formatData.even_Enlace;
        delete formatData.even_Direccion;
        delete formatData.even_LugarEvento;

        const formData = JSON.stringify(formatData);

        console.log("DATA" , dataForm);

        axios.post(
            url,
            JSON.stringify(formData),
            {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8' ,
                    'Accept': 'application/json'
                }
            }
        ).then( data => {
            document.querySelector('.loader').classList.add('loader--hide');
            document.getElementById('content-wrapper').removeAttribute("hidden");

            if (data.data.isSucess){
                toast.success('Evento registrado correctamente. \n Se redireccionará al listado');
                setTimeout(() => { 
                    // window.location.href = BASE_URL_CMS + "/eventos"
                    this.props.history.push({
                        pathname: '/eventos',
                    });

                }, 1000);
            }else{
                this.setState({loading:false});
                toast.error('No se pudo registrar el Evento. \r');
            }
        }).catch((error)=> {
            toast.error('Error no controlado.');
            this.setState({ loading:false });
        });
    }

    handleClickSubmit(e){
        e.preventDefault();
    }

    isRequiredSpan = () => {
        if(
            this.state.event.Even_Estado && 
            this.state.event.Even_Estado.hasOwnProperty("value") && 
            this.state.event.Even_Estado.value === "A"
        ){
            return <span className='font-weight-bold text-danger ml-2'>*</span>
        }else{
            return ""
        }   
    }

    //upload
    handleChangeTab = (event, newValue) => {
        this.setState({numeroTab: newValue});
    };

    onLoad = () => {
        // console.log(this.state.selectsLoadedCount);
        this.setState({
            selectsLoadedCount: this.state.selectsLoadedCount + 1
        }, () => {
            // console.log(this.state.selectsLoadedCount);
            if(this.state.selectsLoadedCount >= 1){
                this.setState({
                    selectsLoaded: true
                });
            }
        });
    }

    changeImg = (flag, routeImg, cod) => {
        let _tmp = {};
        _tmp = updateValueInJson(this.state.event, flag, routeImg);
        _tmp = updateValueInJson(_tmp, 'nImagenCodigo', cod);
        this.setState({ 
            event: _tmp 
        }, () => {
            console.log(this.state.event);
        });
    }

    render(){
        Moment.updateLocale('en', { months : ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio","Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"]});
        Moment.updateLocale('en', { weekdays : [ "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"]});

        let typeselect = "portada";
        if(this.state.numeroTab === 1){
            typeselect = "portada";
        }else if(this.state.numeroTab === 2){
            typeselect = "portadamovil";
        }

        return(
            <div id="detailBody" className="Site-content">
                <div hidden className="loader"></div>

                <form id="frmResource" name="frmResource" autoComplete="off" onSubmit={this.handleClickSubmit} >
                    <div hidden={false} id="content-wrapper" className="d-flex flex-column">
                        <div id="content">
                            <div id="Body" className="body-container container-fluid">

                                <div className="divContenedorBreadcrumbs">
                                    <div className="divCenterBreadcrumbs">
                                        <img src="/static/images/icoBreadcrumb.png" alt="icon-breadcrumb" />
                                            <a href="/">
                                                / Panel de configuración general
                                            </a>
                                            <Link to="/administradores">
                                                / Administradores
                                            </Link>
                                            <Link to="/eventos">
                                                / Eventos
                                            </Link>
                                        <span> / Nuevo evento</span>
                                    </div>
                                </div>
                                <div className="divTitulo_Panel mb-3">
                                    Nuevo evento
                                </div>

                                <div className="row ">
                                    <div className="col-md-12">
                                        <div className="">
                                            <div className="row justify-content-center">
                                                <div className="col-md-10">

                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                
                                                                <div className="form-group">
                                                                    <label className='h6' htmlFor="Even_Titulo">
                                                                        <strong>
                                                                            Título
                                                                            <span className='font-weight-bold text-danger ml-2'>*</span>
                                                                        </strong>
                                                                    </label>

                                                                    <InputWithCounter
                                                                        name="Even_Titulo" 
                                                                        id="Even_Titulo" 
                                                                        onChange={this.handleInputChange} 
                                                                        defaultValue={this.state.event.Even_Titulo} 
                                                                        count={this.state.event.Even_Titulo}
                                                                        maxlength={200}
                                                                        placeholder="Título"
                                                                    />
                                                                </div>

                                                                <div className="form-group">
                                                                    <label className='h6' htmlFor="Even_Extracto">
                                                                        <strong>Extracto</strong>
                                                                        {this.isRequiredSpan()}
                                                                    </label>
                                                                    <TextareaWithCounter
                                                                        name="Even_Extracto" 
                                                                        id="Even_Extracto" 
                                                                        onChange={this.handleInputChange} 
                                                                        defaultValue={this.state.event.Even_Extracto} 
                                                                        count={this.state.event.Even_Extracto}
                                                                        maxlength={500}
                                                                    />
                                                                </div>

                                                                <div className="form-group">
                                                                    <label htmlFor="Even_Tipo" className='h6'>
                                                                        <strong>Tipo de evento</strong>
                                                                        {this.isRequiredSpan()}
                                                                    </label>
                                                                    <div className="">
                                                                        <DropDownList 
                                                                            valor={0} 
                                                                            isMulti={false} 
                                                                            name="Even_Tipo" 
                                                                            id="Even_Tipo"  
                                                                            onChange={this.handleInputChange} 
                                                                            clave={this.state.event.Even_Tipo} 
                                                                            componente={"Even_Tipo"} 
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="form-group">
                                                                    <label className='h6' htmlFor="Even_Extracto">
                                                                        <strong>Banner del evento</strong>
                                                                        {this.isRequiredSpan()}
                                                                    </label>

                                                                    <ImgUploader 
                                                                        // modalImg={() => this.setState({ flagimg: "sImagen" })}
                                                                        value={(this.state.event.Even_ImagenPortada && this.state.event.Even_ImagenPortada !== "") ? this.state.event.Even_ImagenPortada : this.state.event.sImagen}
                                                                        name="Even_ImagenPortada" 
                                                                        id="Even_ImagenPortada" 
                                                                        onChange={(rutaimg, cod) => this.changeImg('sImagen', rutaimg, cod)}
                                                                    />

                                                                    <p style={{fontSize: 15, marginTop: 4}}>
                                                                        Se recomienda la 
                                                                        dimensión de 263px de ancho X 213px de alto. 
                                                                    </p>

                                                                </div>

                                                                {/* 
                                                                <div className="form-group">
                                                                    <label className='h6' htmlFor="Even_Extracto">
                                                                        <strong>Imagen de portada (movil)</strong>
                                                                        {this.isRequiredSpan()}
                                                                    </label>

                                                                    <ImgUploader 
                                                                        // modalImg={() => this.setState({ flagimg: "sImagenMovil" })}
                                                                        value={(this.state.event.Even_ImagenPortadaMovil && this.state.event.Even_ImagenPortadaMovil !== "") ? this.state.event.Even_ImagenPortadaMovil : this.state.event.sImagenMovil}
                                                                        name="Even_ImagenPortadaMovil" 
                                                                        id="Even_ImagenPortadaMovil" 
                                                                        onChange={(rutaimg, cod) => this.changeImg('sImagenMovil', rutaimg, cod)}
                                                                    />

                                                                    <p style={{fontSize: 15, marginTop: 4}}>
                                                                        Se recomienda la 
                                                                        dimensión de 263px de ancho X 213px de alto.
                                                                    </p>
                                                                </div>
                                                                */}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div className="form-group">
                                                                    <label htmlFor="listEventoPais" className='h6'>
                                                                        <strong>Mercado</strong>
                                                                        {this.isRequiredSpan()}
                                                                    </label>
                                                                    <div className="">
                                                                        <DropDownList 
                                                                            valor={[{pais_Id:-999}]} 
                                                                            isMulti={true} 
                                                                            name="listEventoPais" 
                                                                            id="listEventoPais"  
                                                                            onChange={this.handleInputChange} 
                                                                            clave={this.state.event.listEventoPais} 
                                                                            componente={"Ubicacion"} 
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="form-group">
                                                                    <label htmlFor="listEventoPais" className='h6'>
                                                                        <strong>Asistencia</strong>
                                                                        {this.isRequiredSpan()}
                                                                    </label>
                                                                    <div className="">
                                                                        <DropDownList 
                                                                            valor={"0"} 
                                                                            isMulti={false} 
                                                                            name="Even_TipoAsistencia" 
                                                                            id="Even_TipoAsistencia"  
                                                                            onChange={this.handleInputChange} 
                                                                            clave={this.state.event.Even_TipoAsistencia} 
                                                                            componente={"Tipo_asistencia"} 
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="form-group">
                                                                    <label htmlFor="listEventoSector" className='h6'>
                                                                        <strong>Sector</strong>
                                                                        {this.isRequiredSpan()}
                                                                    </label>
                                                                    <div className="">
                                                                        <DropDownList
                                                                            clave={this.state.event.listEventoSector}
                                                                            valor={[{nSectorCodigo:-999}]}

                                                                            child="LineaProducto" 
                                                                            valorHijo={this.state.event.listEventoLineaProducto}

                                                                            name="listEventoSector"
                                                                            id="listEventoSector" 
                                                                            onChange={this.handleInputChange}
                                                                            
                                                                            componente={"EventSector"}
                                                                            isMulti={true} />
                                                                    </div>
                                                                </div>
                                                                
                                                                
                                                                <div className="form-group">
                                                                    <label htmlFor="listEventoFichaProducto" className='h6'>
                                                                        <strong>Producto</strong>
                                                                        {this.isRequiredSpan()}
                                                                    </label>
                                                                    <div className="">
                                                                        <DropDownList 
                                                                            valor={[{pais_Id:-999}]} 
                                                                            isMulti={true} 
                                                                            name="listEventoFichaProducto" 
                                                                            id="listEventoFichaProducto"  
                                                                            onChange={this.handleInputChange} 
                                                                            clave={this.state.event.listEventoFichaProducto} 
                                                                            componente={"fichaProducto"} 
                                                                        />
                                                                    </div>
                                                                </div>
                                                                
                                                                <div className="form-group">
                                                                    <label htmlFor="listEventoPartida" className='h6'>
                                                                        <strong>Partida</strong>
                                                                    </label>
                                                                    <div className="">
                                                                        <DropDownList 
                                                                            name="listEventoPartida" 
                                                                            id="listEventoPartida"
                                                                            onChange={this.handleInputChange}
                                                                            onLoad={() => this.onLoad()}
                                                                            valor={[{part_Id:-999}]}
                                                                            componente={"Partida"}
                                                                            isMulti={true} 
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="nLineaProductoCodigo" className='h6'>
                                                                        <strong>Línea de Producto</strong>
                                                                    </label>
                                                                    <div className="">
                                                                        <DropDownListChild  
                                                                            metodo={"add"} 
                                                                            // valor={0}
                                                                            // etiqueta={"Seleccione una Opción de la Lista"}
                                                                            clavePadre={this.state.event.nSectorCodigo}

                                                                            name="listEventoLineaProducto"
                                                                            parent="Sector" 
                                                                            id="listEventoLineaProducto"
                                                                            onChange={this.handleInputChange}
                                                                            clave={this.state.event.listEventoLineaProducto}
                                                                            componente={"LineaProducto"} 
                                                                            isMultiple={true} 
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="Even_Estado" className='h6'>
                                                                        <strong>
                                                                            Estado
                                                                            <span className='font-weight-bold text-danger ml-2'>*</span>
                                                                        </strong>
                                                                    </label>
                                                                    <div className="">
                                                                        <DropDownList  
                                                                            filtro={this.state.roles}  
                                                                            valor={"P"} 
                                                                            // etiqueta={"PUBLICADO"}  
                                                                            metodo="added"  
                                                                            name="Even_Estado" 
                                                                            id="Even_Estado" 
                                                                            onChange={this.handleInputChange} 
                                                                            clave={this.state.event.Even_Estado} 
                                                                            componente={"Even_Estado"} 
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="Even_Estado" className='h6'>
                                                                        <strong>
                                                                            Estado de actividad
                                                                            <span className='font-weight-bold text-danger ml-2'>*</span>
                                                                        </strong>
                                                                    </label>
                                                                    <div className="">
                                                                        <DropDownList  
                                                                            filtro={[]}  
                                                                            valor={"O"} 
                                                                            metodo="added"  
                                                                            name="Even_EstadoActividad" 
                                                                            id="Even_EstadoActividad" 
                                                                            onChange={this.handleInputChange} 
                                                                            clave={this.state.event.Even_EstadoActividad} 
                                                                            componente={"Even_EstadoActividad"} 
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="Even_CoOrganizador" className='h6'>
                                                                        <strong>Coorganizador<span className='font-weight-bold text-danger ml-2'></span>
                                                                        </strong>
                                                                    </label>
                                                                    <div className="">
                                                                        {/* <input 
                                                                            type="text" 
                                                                            name="Even_CoOrganizador" 
                                                                            id="Even_CoOrganizador" 
                                                                            onChange={this.handleInputChange} 
                                                                            defaultValue={this.state.event.even_CoOrganizador} 
                                                                            className="form-control text-filter__form-control" 
                                                                            maxlength={200}
                                                                            placeholder="Coorganizador" 
                                                                            />   */}

                                                                            <DropDownList 
                                                                                metodo="add" 
                                                                                valor={this.state.event.Even_CoOrganizador === "" ? 0 : this.state.event.Even_CoOrganizador}
                                                                                isMulti={false} 
                                                                                name="Even_CoOrganizador" 
                                                                                id="Even_CoOrganizador"  
                                                                                onChange={this.handleInputChange} 
                                                                                clave={this.state.event.Even_CoOrganizador} 
                                                                                componente={"RECURSO_COORGANIZADOR"} 
                                                                                // placeholder="Seleccionar coorganizador"
                                                                            />

                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label htmlFor="Even_Activo" className='h6'>
                                                                        <strong>Activo</strong>
                                                                        {this.isRequiredSpan()}
                                                                    </label>
                                                                    <div className="">
                                                                        <DropDownList 
                                                                            valor={1} 
                                                                            etiqueta={"ACTIVO"} 
                                                                            metodo="added"  
                                                                            name="Even_Activo" 
                                                                            id="Even_Activo" 
                                                                            onChange={this.handleInputChange} 
                                                                            clave={this.state.event.Even_Activo} 
                                                                            componente={"Even_Activo"} 
                                                                        />
                                                                    </div>
                                                                </div>

                                                            <div className="form-group">
                                                                <label htmlFor="Even_CancelarMotivo" className='h6'><strong>Motivo de cancelación o reprogramación</strong></label>
                                                                    <TextareaWithCounter
                                                                    name="Even_CancelarMotivo" 
                                                                    id="Even_CancelarMotivo" 
                                                                    onChange={this.handleInputChange} 
                                                                    defaultValue={this.state.event.Even_CancelarMotivo} 
                                                                    count={this.state.event.Even_CancelarMotivo}
                                                                    maxlength={90}
                                                                    placeholder="Ingrese el motivo de cancelación/reprogramación"
                                                             />                                                                       
                                                            </div>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="boletin__filters section__margin-bottom">
                                                                <div className="form-group">
                                                                    <label className='h6'>
                                                                        <strong>Fecha de Publicación</strong>
                                                                        {this.isRequiredSpan()}
                                                                    </label>
                                                                    <DatePicker autoComplete="off"
                                                                        className="form-control text-filter__form-control_date col-12"
                                                                        onChange={(val) => this.handleInputChangeDate("Even_FechaPublicacion", val)}
                                                                        value={Moment(this.state.event.Even_FechaPublicacion).format('dddd DD, MMMM YYYY')}
                                                                    />
                                                                </div>

                                                                <div className="form-group">
                                                                    <label className='h6'>
                                                                        <strong>Fecha Inicio del Evento</strong>
                                                                        {this.isRequiredSpan()}
                                                                    </label>
                                                                    <DatePicker autoComplete="off"
                                                                        className="form-control text-filter__form-control_date col-12"
                                                                        onChange={(val) => this.handleInputChangeDate("Even_FechaInicio", val)}
                                                                        value={Moment(this.state.event.Even_FechaInicio).format('dddd DD, MMMM YYYY')}
                                                                    />
                                                                </div>

                                                                <div className="form-group">
                                                                    <label className='h6'>
                                                                        <strong>Fecha Fin del Evento</strong>
                                                                        {this.isRequiredSpan()}    
                                                                    </label>
                                                                    <DatePicker autoComplete="off"
                                                                        className="form-control text-filter__form-control_date col-12"
                                                                        onChange={(val) => this.handleInputChangeDate("Even_FechaFin", val)}
                                                                        value={Moment(this.state.event.Even_FechaFin).format('dddd DD, MMMM YYYY')}
                                                                    />
                                                                </div>
 
                                                             <div className="form-group">
                                                                 <hr></hr>
                                                            </div>

 
                                                            <div className="form-group">
                                                                <label className='h6'><strong>Inicio de inscripción</strong></label>
                                                                <DatePicker autoComplete="off"
                                                                    isClearable
                                                                    className="form-control text-filter__form-control_date col-12"
                                                                    onChange={(val) => this.handleInputChangeDate("Even_FechaIncripcionIni", val)}
                                                                    selected={this.state.event.Even_FechaIncripcionIni ? new Date(this.state.event.Even_FechaIncripcionIni) : null}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    placeholderText="Seleccione fecha inicio"
                                                                />
                                                            </div>

                                                            <div className="form-group">
                                                                <label className='h6'><strong>Fin de inscripción</strong></label>
                                                                <DatePicker autoComplete="off"
                                                                    isClearable
                                                                    className="form-control text-filter__form-control_date col-12"
                                                                    onChange={(val) => this.handleInputChangeDate("Even_FechaIncripcionFin", val)}
                                                                    selected={this.state.event.Even_FechaIncripcionFin ? new Date(this.state.event.Even_FechaIncripcionFin) : null}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    placeholderText="Seleccione fecha fin"
                                                                />
                                                            </div>

                                                            <hr />

                                                            <div className="form-group border p-2 bg-light d-flex align-items-center" style={{ borderRadius: '4px' }}>
                                                                <Checkbox
                                                                    id="chkRepro"
                                                                    checked={this.state.isReprogramado}
                                                                    onChange={this.handleToggleReprogramado}
                                                                    color="primary"
                                                                    style={{ padding: '5px' }}
                                                                />
                                                                <label className="h6 mb-0 ml-2" htmlFor="chkRepro" style={{ cursor: 'pointer', marginTop: '4px' }}>
                                                                    <strong>¿Evento Reprogramado?</strong>
                                                                </label>
                                                            </div>

                                                            {this.state.isReprogramado && (
                                                                <div className="p-3 mb-3 border rounded shadow-sm" style={{backgroundColor: '#fff'}}>
                                                                    <div className="form-group">
                                                                        <label className='h6 '><strong>Nueva fecha inicio</strong> *</label>
                                                                        <DatePicker autoComplete="off"
                                                                            isClearable
                                                                            className="form-control text-filter__form-control_date col-12"
                                                                            onChange={(val) => this.handleInputChangeDate("Even_FechaReproIni", val)}
                                                                            selected={this.state.event.Even_FechaReproIni ? new Date(this.state.event.Even_FechaReproIni) : null}
                                                                            dateFormat="dd/MM/yyyy"
                                                                            placeholderText="Inicio reprogramado"
                                                                        />
                                                                    </div>
                                                                    <div className="form-group mb-0">
                                                                        <label className='h6'><strong>Nueva fecha fin</strong> *</label>
                                                                        <DatePicker autoComplete="off"
                                                                            isClearable
                                                                            className="form-control text-filter__form-control_date col-12"
                                                                            onChange={(val) => this.handleInputChangeDate("Even_FechaReproFin", val)}
                                                                            selected={this.state.event.Even_FechaReproFin ? new Date(this.state.event.Even_FechaReproFin) : null}
                                                                            dateFormat="dd/MM/yyyy"
                                                                            placeholderText="Fin reprogramado"
                                                                        />
                                                                    </div>
                                                                </div>
                                                              )}

                                                                <div className="form-group">
                                                                    <label htmlFor="even_Enlace" className='h6'>
                                                                        <strong>Enlace del evento</strong>
                                                                        {this.isRequiredSpan()}    
                                                                    </label>
                                                                    <input 
                                                                        type="text" 
                                                                        name="even_Enlace" 
                                                                        id="even_Enlace" 
                                                                        onChange={this.handleInputChange} 
                                                                        defaultValue={this.state.event.even_Enlace} 
                                                                        className="form-control text-filter__form-control" 
                                                                        placeholder="Enlace de interés" 
                                                                    />
                                                                </div>
                                                                <div className="form-group">
                                                                        <label htmlFor="even_Direccion" className='h6'>
                                                                            <strong>Dirección</strong>
                                                                            {this.isRequiredSpan()}
                                                                        </label>
                                                                        <input 
                                                                            type="text" 
                                                                            name="even_Direccion" 
                                                                            id="even_Direccion" 
                                                                            onChange={this.handleInputChange} 
                                                                            defaultValue={this.state.event.even_Direccion} 
                                                                            className="form-control text-filter__form-control" 
                                                                            maxlength={200}
                                                                            placeholder="Dirección del evento" 
                                                                        />
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label htmlFor="even_LugarEvento" className='h6'>
                                                                            <strong>Lugar del evento</strong>
                                                                            {this.isRequiredSpan()}
                                                                        </label>
                                                                        <input 
                                                                            type="text" 
                                                                            name="even_LugarEvento" 
                                                                            id="even_LugarEvento" 
                                                                            onChange={this.handleInputChange} 
                                                                            defaultValue={this.state.event.even_LugarEvento} 
                                                                            className="form-control text-filter__form-control" 
                                                                            maxlength={200}
                                                                            placeholder="Lugar del evento" 
                                                                        />
                                                                    </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* 
                                                        <ModalImages
                                                            flag={this.state.flagimg}
                                                            onSelectImg={this.changeImg}
                                                        />
                                                    */}

                                                    <div className="d-flex justify-content-start mb-3">
                                                        <div className="d-flex justify-content-start">
                                                            <button 
                                                                type="button" 
                                                                onClick={(event) => this.handleClickCancel(event)} 
                                                                className="btn btn-default btn-primary__submit"
                                                            >
                                                                Cancelar
                                                            </button>
                                                            &nbsp;
                                                            <ButtonLoader 
                                                                bloqueado={!this.state.selectsLoaded}
                                                                text="GUARDAR" 
                                                                textProcessing="PROCESANDO..." 
                                                                loading={this.state.loading} 
                                                                callFunctionButton={(e) => this.callFunctionButton(e)}
                                                            ></ButtonLoader>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

                
            </div>
        )
    }
}   

export default AddEventos;